import moment from 'moment';
import Sounds from '@/utils/sound-effects';

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

const numberOfFlipped = cards => (cards.filter(card => card.flipped).length);

const hasMatches = cards => {
  const flippedCards = cards.filter(card => card.flipped);
  return flippedCards.every(card => card.value === flippedCards[0].value);
};

export const flipCard = async({ state, commit }, item) => {
  if (item.flipped === false && numberOfFlipped(state.cards) === 2) {
    commit('setAllCardsUnflipped');
    commit('setCardFlipped', item);
    Sounds.flipNormal(item).play();
  } else if (item.flipped === false && numberOfFlipped(state.cards) < 2) {
    commit('setCardFlipped', item);

    if (numberOfFlipped(state.cards) === 2) {
      state.result = moment().diff(state.startTime);

      if (hasMatches(state.cards)) {
        commit('setFlippedCardsToMatched');
        Sounds.flipMatch().play();
      } else {
        Sounds.flipNormal(item).play();
      }
    } else {
      Sounds.flipNormal(item).play();
    }

    if (state.cards.every(card => card.matched)) {
      if (state.level < state.game.levels.length - 1) {
        Sounds.levelUp(state.level).play();
        await wait(1000);
        commit('increaseLevel');
        commit('generateCards');
      } else {
        commit('stopTimer');
        await wait(1000);
        commit('showResult');
      }
    }
  }
};
